<div class="page main-signin-wrapper">
    <section class="signup__area po-rel-z1 pt-100 pb-145">
        <div class="container shapes-div">
            <div class="row">
                <div class="sign__shape">
                    <img src="assets/images/man-1.png" alt="" class="man-1" />
                    <img src="assets/images/man-2.png" alt="" class="man-2" />
                    <img src="assets/images/circle.png" alt="" class="circle" />
                    <img src="assets/images/zigzag.png" alt="" class="zigzag" />
                    <img src="assets/images/dot.png" alt="" class="dot" />
                    <img src="assets/images/sign-up.png" alt="" class="bg" />
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-xl-8 offset-xl-2">
                    <div class="section__title-wrapper text-center mb-5">
                        <h2 class="section__title">Forget Password</h2>
                        <!-- <p>If You Don't Have An Account You Can Register Here!</p> -->
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
                    <div class="sign__wrapper white-bg">
                        <div class="sign__form">
                            <form [formGroup]="loginForm" novalidate>
                                <div class="sign__input-wrapper mb-4">
                                    <h5>User Name</h5>
                                    <div class="sign__input">
                                        <input type="text" maxlength="50" formControlName="LoginName" required id="LoginName"
                                            placeholder="User Id" />
                                            <i class="fa fa-user"></i>
                                        <!-- <i class="fa fa-envelope"></i> -->
                                        <mat-error class="margin_tp"
                                            *ngIf="loginForm.controls['LoginName'].touched && loginForm.controls['LoginName'].errors?.required">
                                            Mandatory
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="sign__input-wrapper mb-4">
                                    <h5>Email Id</h5>
                                    <div class="sign__input">
                                        <input type="text" formControlName="LoginEmail" required id="LoginEmail"
                                            placeholder="Email Id" />
                                            <i class="fa fa-envelope"></i>
                                        <!-- <i class="fa fa-envelope"></i> -->
                                        <mat-error class="margin_tp"
                                        *ngIf="loginForm.controls['LoginEmail'].touched && loginForm.controls['LoginEmail'].errors?.pattern">
                                        Invalid
                                    </mat-error>
                                        <mat-error class="margin_tp"
                                            *ngIf="loginForm.controls['LoginEmail'].touched && loginForm.controls['LoginEmail'].errors?.required">
                                            Mandatory
                                        </mat-error>
                                    </div>
                                    <!-- <div class="sign__input">
                                        <input name="password" class="form-control" id="LoginEmail" required
                                            placeholder="Password" formControlName="LoginEmail">
                                        <mat-error class="margin_tp"
                                            *ngIf="loginForm.controls['LoginEmail'].touched && loginForm.controls['LoginEmail'].errors?.required">
                                            This Field Is Mandatory
                                        </mat-error>
                                    </div> -->
                                </div>
                                <div class="sign__action d-sm-flex justify-content-between mb-4">

                                    <button class="e-btn siz w-100 colfff" type="submit" (click)="Submit()">Submit</button>
                                    <button class="e-btn w-100 colfff" type="submit" (click)="Back()">Back</button>
                                </div>
                                <div class="sign__new text-center mt-3" *ngIf="Message">
                                    <p>New Password Has Been Sent To Your Email Id</p>
                                </div>
                                <div class="sign__action d-sm-flex justify-content-between mb-4"  *ngIf="Message">
                                    <button class="e-btn w-100 colfff" type="submit" (click)="Back()">SignUp</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>